import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Address
 * @exports Service/Account/OrganisationAddress
 * @description API Organisation Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class OrganisationAddress {
	/**
	 * @static @name modify
	 * @description Update some Organisation address for ID
	 * @param {String} id
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static patch(id, payload) {
		return $http.patch(`account/organisation/address/${id}`, payload);
	}
}
